/**
 * Espejo cliente de la matriz de visibility. El backend ya filtra/gating;
 * acá filtramos en cliente para no mostrar definiciones que el usuario no
 * puede ver (UX), pero NO confiamos en eso para seguridad.
 *
 * Igual que apps/api/src/lib/eval-visibility.ts.
 */
import type { SessionUser } from "@axorial/shared";

type Role = SessionUser["role"];

export function canSeeDef(visibility: string, role: Role): boolean {
  if (role === "admin") return true;
  switch (visibility) {
    case "everyone":
      return true;
    case "lead":
      return role === "lead" || role === "finanzas";
    case "finanzas":
      return role === "finanzas";
    case "admin_only":
      return false;
    default:
      if (visibility === "public") return true;
      if (visibility === "private") return false;
      return false;
  }
}

export function canCaptureDef(visibility: string, role: Role): boolean {
  if (role === "admin") return true;
  switch (visibility) {
    case "everyone":
      return role === "lead";
    case "lead":
      return role === "lead" || role === "finanzas";
    case "finanzas":
      return role === "finanzas";
    case "admin_only":
      return false;
    default:
      return role === "lead" || role === "finanzas";
  }
}
